import { MD_BREAKPOINT } from '../constants/brakepoints';

export const isMobile = () => window.screen.width < MD_BREAKPOINT;
